import React from 'react';
import { Button, makeStyles, Theme, Chip } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { useManageContext } from '../../../../../contexts/ManageContext/ManageContext';
import { useAuthUser } from '../../../../../contexts/AuthProvider/hooks';

const useStyles = makeStyles((theme: Theme) => ({
  orgsButton: {
    textTransform: 'none',
  },
  buttonDisabled: {
    '&.Mui-disabled': {
      color: 'inherit',
      opacity: theme.palette.action.disabledOpacity,
    },
  },
  selectedOrgName: {
    whiteSpace: 'nowrap',
    overflow: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      width: '0px',
      background: 'transparent',
    },
  },
  orgMenu: {
    paddingBottom: 0,
  },
  submitButton: {
    justifyContent: 'flex-end',
    position: 'sticky',
    bottom: 0,
    backgroundColor: theme.palette.background.default,
  },
}));

const MenuOrgs = () => {
  const { state, dispatch } = useManageContext();
  const classes = useStyles();
  const { authUser } = useAuthUser();
  const { selectedOrgs } = state;

  return (
    <>
      <Button
        size="large"
        color="inherit"
        classes={{ disabled: classes.buttonDisabled }}
        className={classes.orgsButton}
        aria-haspopup="dialog"
        onClick={(e) => {
          dispatch({ type: 'org-selection', data: { visible: true } });
        }}
      >
        <span className={classes.selectedOrgName}>Organizations</span>
        <KeyboardArrowDownIcon />
        <Chip
          label={
            selectedOrgs && selectedOrgs.length !== 0
              ? selectedOrgs.length
              : authUser.orgs.length
          }
        />
      </Button>
    </>
  );
};

export default MenuOrgs;
